import { useEffect, useState, useCallback } from "react";

export function useScrollToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined" || typeof document === "undefined") return;

    const nav = document.querySelector<HTMLElement>('[data-testid="navbar-bar"]');
    const threshold = nav?.offsetHeight ?? 80;

    const handleScroll = () => {
      setVisible(window.scrollY > threshold);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = useCallback(() => {
    if (typeof window === "undefined") return;

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return { visible, scrollToTop };
}
